// Логотип бренда для всего React-приложения. Для сезонной смены меняем только путь здесь.
// Основной логотип: '/images/skinoz-new-logo.png'
export const LOGO_SRC = '/images/skinoz-logo-halloween.png'

// Картинка для glitch-логотипа прелоадера. null — исходный фирменный SVG-логотип.
export const LOADER_LOGO_SRC = LOGO_SRC

// Хэллоуинская тема на всё приложение (туман «Котёл», паутина, молнии) — src/features/halloween.
export const HALLOWEEN_THEME = true
